<template>
    <div class="title-desc">
        <slot name="title">
            <p v-html="title" v-if="title && title.length" class="title-desc__text title-desc__title">
                {{title}}
            </p>
        </slot>
        <slot name="description">
            <p v-if="description && description.length" class="title-desc__text title-desc__description">
                {{description | truncate(800)}}
            </p>
        </slot>
    </div>
</template>

<script>
import { truncate } from '../../core/filters'
export default {
    name: 'TitleDescription',
    props: {
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        }
    },
    filters: {
        truncate
    }
}
</script>
<style lang="scss">
:root {
    --title-fontsize: 24px;
    --title-lineheight: 32px;
    --title-margin-bottom: 16px;
    --description-fontsize: 16px;
    --description-lineheight: 24px;
    --description-margin-bottom: 0;

    --title-font: 'Eina Bold';
    --description-font: 'Eina';

    --title-color: #333333;
    --description-color: #333333;
}
</style>
<style lang="scss" scoped>
.title-desc {
    &__title {
        font-size: var(--title-fontsize);
        line-height: var(--title-lineheight);
        color: var(--title-color);
        margin-bottom: var(--title-margin-bottom);
        font-family: var(--title-font);
    }
    &__description {
        font-size: var(--description-fontsize);
        line-height: var(--description-lineheight);
        color: var(--description-color);
        margin-bottom: var(--description-margin-bottom);
        font-family: var(--description-font);
        overflow-wrap: break-word;
    }
}
</style>>
